/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import VoxeetSDK from '@voxeet/voxeet-web-sdk';

import 'antd/dist/antd.css';

import './App.css';

import { Auth } from './pages/auth';
import { SpaceList, Space } from './pages/spaces';
import { Room } from './pages/rooms';
import { useUserStore } from "./stores/user";
import { request } from "./libs/utils";
import { useSpaceStore } from './stores/space';

function App() {
  const { confirm, isLoggedIn, getFB, load, initiateDolby } = useUserStore();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    if(window.location.hash.indexOf('#confirmation_token') >= 0){
      const token = window.location.hash.split('=')[1];
      confirm(token, true).then(async user => {
        navigate('/auth');
        setLoading(false);
      })
      .catch(err => {
        navigate('/auth?confirmation=failed');
        setLoading(false);
      });
    }
    else if(isLoggedIn){
      initiateDolby()
      .then(async () => {
        await getFB();
        setLoading(false);
        setTimeout(() => {
          if(window.location.pathname === '/' || window.location.pathname === '/auth'){
            const user = load();
            if(user.officeId){
              navigate(`/spaces/${user.officeId}`);
            }
            else{
              navigate(`/spaces`);
            }
          }
        });
      });
    }
    else if(!isLoggedIn){
      if(window.location.pathname !== '/auth'){
        navigate(`/auth?r=${window.location.pathname}`);
      }
      setLoading(false);
    }
  }, []);
  return (
    <div className="App">
      {!loading && <Routes>
        <Route path="/auth" element={<Auth />} />
        <Route path="/auth/register" element={<Auth register />} />
        <Route path="/spaces" element={<SpaceList />} />
        <Route path="/spaces/:id" element={<Space />} />
        <Route path="/room/:id" element={<Room />} />
      </Routes>}
    </div>
  );
}

export default App;
